import { GET } from '@/api';

const URL = '/contact-us/get-form-elements?enquiryTypeCode=';

export default async ({ enquiryTypeCode, config, successCB, failCB }) => {
  try {
    const { data } = await GET(`${URL}${enquiryTypeCode}`, config);
    return (typeof successCB === 'function' && successCB(data)) || data;
  } catch (e) {
    return (typeof failCB === 'function' && failCB(e)) || e;
  }
};
